export default {
  root: {
    path: '/user/info',
    displayName: 'Home',
    disabled: true,
  },
  routes: [
    // 会員画面
    {
      path: 'info',
      displayName: 'ご挨拶'
    },
    {
      path: 'candi',
      displayName: '立候補する'
    },
    {
      path: 'vote',
      displayName: 'aaaaa'
    },
    {
      path: 'vote-list',
      displayName: '立候補者一覧',
      children: [
        {
          path: 'vote-detail',
          displayName: '詳細情報',
          disabled: true,
        }
      ]
    },
    {
      path: 'update',
      displayName: '会員情報変更'
    },

    // 管理画面
    {
      path: 'users',
      displayName: '会員情報',
      disabled: true,
      children: [
        {
          path: 'user-list',
          displayName: '会員一覧',
        },
        {
          path: 'user-insert',
          displayName: '会員新規追加',
        },
        {
          path: 'user-upload',
          displayName: '一括アップロード',
        }
      ]
    },
    {
      path: 'mail',
      displayName: 'メール',
      disabled: true,
      children: [
        {
          path: 'mail-send',
          displayName: '一括メール送信',
        },
        {
          path: 'mail-history',
          displayName: '送信履歴',
        }
      ]
    },
    {
      path: 'election',
      displayName: '選挙管理',
      disabled: true,
      children: [
        {
          path: 'election-update',
          displayName: '選挙情報入力',
        },
        {
          path: 'election-vote-list',
          displayName: '立候補者一覧',
        },
        {
          path: 'election-analytics',
          displayName: '得票状況',
        }
      ]
    },
    {
      path: 'info-update',
      displayName: 'あいさつ文編集',
    },




    {
      path: 'dashboard',
      displayName: 'menu.dashboard'
    },
    {
      path: 'statistics',
      displayName: 'menu.statistics',
      disabled: true,
      children: [
        {
          path: 'charts',
          displayName: 'menu.charts',
        },
        {
          path: 'progress-bars',
          displayName: 'menu.progressBars'
        },
      ]
    },
    {
      path: 'forms',
      displayName: 'menu.forms',
      disabled: true,
      children: [
        {
          path: 'form-elements',
          displayName: 'menu.formElements'
        },
        {
          path: 'form-wizards',
          displayName: 'menu.formWizards'
        },
        {
          path: 'medium-editor',
          displayName: 'menu.mediumEditor'
        }
      ]
    },
    {
      path: 'tables',
      displayName: 'menu.tables'
    },
    {
      path: 'ui',
      displayName: 'menu.uiElements',
      disabled: true,
      children: [
        {
          path: 'typography',
          displayName: 'menu.typography'
        },
        {
          path: 'buttons',
          displayName: 'menu.buttons'
        },
        {
          path: 'color-pickers',
          displayName: 'menu.colorPickers'
        },
        {
          path: 'notifications',
          displayName: 'menu.notifications'
        },
        {
          path: 'icons',
          displayName: 'menu.icons'
        },
        {
          path: 'spinners',
          displayName: 'menu.spinners',
        },
        {
          path: 'grid',
          displayName: 'menu.grid',
        },
        {
          path: 'modals',
          displayName: 'menu.modals'
        },
        {
          path: 'file-upload',
          displayName: 'menu.fileUpload'
        },
        {
          path: 'tags',
          displayName: 'menu.tags'
        },
        {
          path: 'cards',
          displayName: 'menu.cards'
        },
        {
          path: 'tree-view',
          displayName: 'menu.treeView'
        }
      ]
    },
    {
      path: 'extra',
      displayName: 'menu.extra'
    },
    {
      path: 'maps',
      displayName: 'menu.maps',
      disabled: true,
      children: [
        {
          path: 'google-maps',
          displayName: 'Google Maps'
        },
        {
          path: 'yandex-maps',
          displayName: 'Yandex Maps'
        },
        {
          path: 'leaflet-maps',
          displayName: 'Leaflet Maps',
        },
        {
          path: 'bubble-maps',
          displayName: 'Bubble Maps',
        },
        {
          path: 'line-maps',
          displayName: 'Line Maps'
        }
      ]
    },
    {
      path: 'pages',
      displayName: 'menu.pages',
      disabled: true,
      children: [
        {
          path: '404-pages',
          displayName: '404 Pages'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/admin/app-breadcrumbs/Breadcrumbs.js